import { render, staticRenderFns } from "./branches.vue?vue&type=template&id=67bbcb92&scoped=true&"
import script from "./branches.vue?vue&type=script&lang=js&"
export * from "./branches.vue?vue&type=script&lang=js&"
import style0 from "./branches.vue?vue&type=style&index=0&id=67bbcb92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bbcb92",
  null
  
)

export default component.exports